import React from 'react';
import { Card, Badge } from 'react-bootstrap';

const TechnicalStatus = ({ stats }) => {
    return (
        <Card>
            <Card.Header className="bg-secondary text-white">
                <h5 className="mb-0">
                    <i className="bi bi-hdd me-2"></i>
                    Technical Status
                </h5>
            </Card.Header>
            <Card.Body>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <span>Database Uptime</span>
                    <Badge bg="dark">
                        {stats.database_uptime_hours || 'N/A'}
                    </Badge>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-3">
                    <span>Database Size</span>
                    <Badge bg="dark">
                        {stats.database_size || 'N/A'}
                    </Badge>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <span>Cache Hit Ratio</span>
                    <Badge bg={parseFloat(stats.cache_hit_ratio) > 90 ? 'success' : 'warning'}>
                        {stats.cache_hit_ratio ? `${parseFloat(stats.cache_hit_ratio).toFixed(2)}%` : 'N/A'}
                    </Badge>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <span>Avg Query Time</span>
                    <Badge bg="dark">
                        {stats.avg_query_time ? `${parseFloat(stats.avg_query_time).toFixed(2)}ms` : 'N/A'}
                    </Badge>
                </div>
                <div className="d-flex justify-content-between align-items-start mb-3">
                    <span>Database Version</span>
                    <span bg="dark" className="text-break" style={{ maxWidth: '60%', textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                        <i>{stats.database_version || 'N/A'}</i>
                    </span>
                </div>
            </Card.Body>
        </Card>
    );
};

export default TechnicalStatus;
